import dayjs from "dayjs";

export function dayjsOrAny(value: any) {
    if (value === undefined) return null;
    if (!value || !dayjs(value).isValid) return value;
    return dayjs(value);
}
